<template>
  <billing-report-panel
    report-key="guides-to-bill"
    route="/reports/billing-guides-to-bill"
    file-name="guias-a-faturar.xlsx"
    period-label="Período do atendimento"
    :columns="columns"
    :default-days="360"
    show-professional
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Faixa de tempo de espera',
        'Guia',
        'Paciente',
        'Profissional',
        'Tipo de guia',
        'Data do atendimento',
        'Dias parados',
        'Valor da guia',
        'Subtotal por faixa',
      ],
    };
  },
};
</script>
